// extracted by mini-css-extract-plugin
export default {"frame":"KycVerificationFrame_frame__OxdtW","fill":"KycVerificationFrame_fill__itzsj","hostWrapper":"KycVerificationFrame_hostWrapper__+zCFg"};